import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap/modal';

import { AngularModalComponent } from './angular-modal.component';

@NgModule({
    imports: [ ModalModule.forRoot(), CommonModule ],
    declarations: [AngularModalComponent],
    exports: [AngularModalComponent],
    providers: []
})
export class AngularModalModule { }


// WEBPACK FOOTER //
// ./src/angular_library/components/modal/angular-modal.module.ts